import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { GetPermitTypeById, GetPermitTypeByIdVariables } from "./__generated__/GetPermitTypeById";
import { PERMIT_TEMPLATE_FIELDS } from "../fragments/PermitTemplate";
import { ORG_ROLE_FIELDS } from "../fragments/OrgRole";

export const GET_PERMIT_TYPE_BY_ID = gql`
  ${PERMIT_TEMPLATE_FIELDS}
  ${ORG_ROLE_FIELDS}
  query GetPermitTypeById($organizationId: String!, $permitTypeId: String!) {
    permitTypeById(organizationId: $organizationId, permitTypeId: $permitTypeId) {
      id
      name
      blueprintKey
      version
      template {
        ...PermitTemplateFields
      }
      roles {
        id
        orgRole {
          ...OrgRoleFields
        }
        settings {
          isPermitAssignee
          mandatoryOnSubmission
          shouldAuthorizePermit
          authorizationDeclaration
        }
      }
      documentTypes {
        id
        documentType {
          id
          name
          key
          settings {
            declaration
            requirement {
              key
              name
            }
          }
          isArchived
        }
        settings {
          declaration
          requirement {
            key
            name
          }
        }
      }
    }
  }
`;

export function useLazyGetPermitTypeById() {
  const [getPermitTypeById, { loading, error, data, refetch }] = useLazyQuery<
    GetPermitTypeById,
    GetPermitTypeByIdVariables
  >(GET_PERMIT_TYPE_BY_ID, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getPermitTypeById,
    data: data?.permitTypeById,
    refetch,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
